import config from 'services/config'

export const getImgUrlFromCDN = (fileName, mediaTag, hotelId) => {
  const mediaTagRegex = new RegExp(`^c/|a/`)
  const cleanFileName = fileName.replace(mediaTagRegex, '')

  return `${config.inviteMediaBaseUrl}/${hotelId}/${mediaTag}/${cleanFileName}`
}

export const isCampaignImageVisible = mediaUrl => {
  const extension = getExtensionFromUrl(mediaUrl)
  return extension !== 'pdf'
}

export const getExtensionFromUrl = url => {
  const urlParts = url.split('.')
  return urlParts[urlParts.length - 1]
}
